import { render, staticRenderFns } from "./ModuleLessons.vue?vue&type=template&id=f2d71ac6"
import script from "./ModuleLessons.vue?vue&type=script&lang=js"
export * from "./ModuleLessons.vue?vue&type=script&lang=js"
import style0 from "./ModuleLessons.vue?vue&type=style&index=0&id=f2d71ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports